<template>
  <div>
    <mapa-con-marcador
      title="Seleccione la Ubicación"
      :isMobile="isMobile"
      :height="630"
      @locationSaved="handleLocationSaved"
    />
  </div>
</template>

<script>
import MapaConMarcador from '@/components/Mapas/MapaConMarcador.vue';

export default {
  components: {
    MapaConMarcador
  },
  data() {
    return {
      isMobile: true,
    };
  },
  methods: {
    handleLocationSaved(location) {
      console.log('Ubicación guardada:', location);
      // Aquí puedes hacer lo que necesites con la ubicación guardada, como enviarla a un servidor
    },
  },
};
</script>